module.exports = __webpack_public_path__ + "static/media/dashboard_light.c5f0dc9e.svg";